import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import querystring from 'RootShared/utility/querystring';

import { queryGetProfileData } from '../../screens/Profile/Profile';

const RawProfilePreview = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { data } = useQuery(queryGetProfileData);

  const handleOpenProfile = useCallback(() => {
    const newQuery = querystring.substitute(search, 'profileTab', 'personal');

    history.push(`${pathname}?${newQuery}`);
  }, [history, pathname, search]);

  const user = data && data.user ? data.user : { email: '', firstName: '', lastName: '' };

  let { email = '', firstName = '', lastName = '' } = user || {};

  return (
    <div className="profile-preview" data-testid="profile-preview-widget" onClick={handleOpenProfile}>
      <span className="profile-preview__name">{`${firstName.trim()} ${lastName.trim()}`}</span>
      <span className="profile-preview__email" data-testid="profile-email">
        {email.trim()}
      </span>
    </div>
  );
};

const ProfilePreview = (props) => {
  return <RawProfilePreview {...props} />;
};

export default ProfilePreview;
